module.exports = {"mobile":450,"desktop":1000,"hd":1250}


//////////////////
// WEBPACK FOOTER
// ./breakpoints.json
// module id = zVJj
// module chunks = 16